import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/auth/profile */
export async function currentUser(): Promise<API.USER.User> {
  return request<API.USER.CurrentUserResult>('/getInfo', {
    method: 'GET',
  }).then((res) => {
    return res.user;
  });
}

/** 登录接口 POST /api/login */
export async function login(body: API.USER.LoginParams) {
  return request<API.USER.LoginResult>('/login', {
    method: 'POST',
    data: body,
  });
}

/** 图片验证码 Get /api/captchaImage */
export async function getCaptcha() {
  return request<API.USER.LoginCaptchaResult>('/captchaImage', {
    method: 'GET',
  });
}

/** 退出登录接口 POST /logout */
export async function logout() {
  return request('/logout', {
    method: 'POST',
  });
}
